import AOS from 'aos'
import Parallax from 'parallax-js'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import MobileDetect from 'mobile-detect'
import { openModal, closeModal } from '../components/modal'


// AOS
const useAOS = () => {
  const offset = () => window.innerHeight * 0.2

  AOS.init({
    once: true,
    mirror: true,
    duration: 800,
    offset: offset()
  })
}

// Parallax-js
// 在父層加上 data-parallax，並於要做效果的元素加上 data-depth 便可啟動 Parallax 效果
// 若只要在滑鼠進入父層才有效果，則於父層加上 data-parallax-hover
const useParallax = () => {
  const md = new MobileDetect(window.navigator.userAgent);
  if (md.mobile()) return;

	let parallaxInstance = []
	const scene = $('[data-parallax]')

	scene.each((i, el) => {
    const isHoverOnly = el.getAttribute('data-parallax-hover') !== undefined

		parallaxInstance[i] = new Parallax(el, {
			relativeInput: true,
			hoverOnly: isHoverOnly,
			invertX: false,
			invertY: false
		})
	})
}

// 圖片滾動視差效果
// 在欲做視差的圖片加上 class="data-image-parallax"，會自動抓其父層做為容器，或可於其更上層加上 data-image-parallax-trigger 做為容器
// data-image-parallx 若有填入數字 (ex. data-image-parallax="100" || data-image-parallax="50%") 則以填入數字做位移，若無填入則以子層扣掉父層高度多餘的值做位移
// data-image-parallx-rotate 可加入旋轉位移
const useImageParallax = () => {
  gsap.registerPlugin(ScrollTrigger)

  const images = $('[data-image-parallax]')
  images.each((i, el) => {
    const image = $(el)
    const trigger = image.closest('[data-image-parallax-trigger]').length ? image.closest('[data-image-parallax-trigger]') : image.parent()
    const translateY = el.getAttribute('data-image-parallax') || image.innerHeight() - trigger.innerHeight()
    const rotate = el.getAttribute('data-image-parallax-rotate')

    if (!translateY) return;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: trigger[0],
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
      }
    })

    const gsapTo = {
      y: translateY
    }
    if (rotate) {
      gsapTo.rotate = rotate
    }

    tl.to(el, gsapTo)
  })
}

// youtube 
const useYoutube = () => {
  const triggers = $('[data-youtube-id]')
  const isYoutubeModalExist = $('#youtube-modal')
  const youtubeModal = isYoutubeModalExist.length ? isYoutubeModalExist : $('<div class="modal space-lr" id="youtube-modal"><div class="modal-bg"></div><div class="modal-container"><div class="modal-content"><div class="close-btn"><button><div class="icon-cross"></div></button></div><div class="video-box" data-modal-prevent><iframe src="" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div></div></div></div>')
  youtubeModal.find('.modal-container').on('click', e => {
    const isPrevent = $(e.target).closest('[data-modal-prevent]').length
    if (isPrevent) return;
    closeModal(youtubeModal)
  })
  youtubeModal.find('.close-btn').on('click', () => closeModal(youtubeModal))

  if (!isYoutubeModalExist.length) $('body').append(youtubeModal)

  triggers.each((i, el) => {
    const trigger = $(el)
    const youtubeId = trigger.attr('data-youtube-id')
    const isAppendBtn = trigger.attr('data-youtube-btn') !== 'false'
    if (!youtubeId) return;

    // 加入 youtube-trigger-cover
    if (isAppendBtn) {
      const coverEl = $('<div class="youtube-trigger-cover" data-modal-open="#youtube-modal"><div class="youtube-trigger-btn play-btn"></div></div>')
      trigger.css({ position: 'relative' }).append(coverEl)
    }

    // 點擊打開燈箱
    trigger.on('click', () => {
      youtubeModal.find('iframe')[0].src = `https://www.youtube.com/embed/${youtubeId}`
      setTimeout(() => {
        openModal(youtubeModal)
      }, 100);
    })
  })
}

// copy url
const useCopyURL = () => {
  const targets = $('.copyurl-btn')
  const clipboardNote = $('<div class="clipboard-note">URL COPIED !</div>')
  const showClipboardNote = (text) => {
    clipboardNote.show()
    if (text) clipboardNote.text(text)
    setTimeout(() => {
      clipboardNote.addClass('is-show')
      setTimeout(() => {
        clipboardNote.addClass('is-leaving')
        setTimeout(() => {
          clipboardNote.hide()
          clipboardNote.removeClass('is-show is-leaving')
        }, 500)
      }, 1000)
    }, 50)
  }

  $('body').append(clipboardNote)

  targets.on('click', () => {
    const url = document.location.href

    navigator.clipboard.writeText(url).then(() => {
      showClipboardNote()
    }, () => {
      showClipboardNote('Copy URL Failed !')
    })
  })
}


export {
  useAOS,
  useParallax,
  useImageParallax,
  useYoutube,
  useCopyURL
}